import React, { useRef, useState, useEffect } from 'react';
import { formatPrice } from '../utils/currency';
import { ArrowLeft, ArrowRight } from 'iconoir-react';

function ProdutoCarousel({ produtos, onProdutoClick, titulo = "Produtos em Destaque", titleColor = '#1f2937', cardHeight, variant = 'principal' }) {
  const carouselRef = useRef(null);

  

  const scrollLeft = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: -80, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: 280, behavior: 'smooth' });
    }
  };

  const [bgPos, setBgPos] = useState({});
  const [hovered, setHovered] = useState({});
  const [isMobile, setIsMobile] = useState(false);

  const variantStyles = {
    principal: { cardHeight: 360, cardWidth: 280, bgSize: '110%', bgSizeHover: '114%', overlayHeight: '55%' },
    secundario: { cardHeight: 220, cardWidth: 260, bgSize: '108%', bgSizeHover: '112%', overlayHeight: '50%' },
    terciario: { cardHeight: 100, cardWidth: 330, bgSize: '106%', bgSizeHover: '108%', overlayHeight: '45%' },
  };
  const variantStylesMobile = {
    principal: { cardHeight: 360, cardWidth: 240, bgSize: '112%', bgSizeHover: '116%', overlayHeight: '55%' },
    secundario: { cardHeight: 190, cardWidth: 220, bgSize: '110%', bgSizeHover: '114%', overlayHeight: '50%' },
    terciario: { cardHeight: 170, cardWidth: 330, bgSize: '108%', bgSizeHover: '112%', overlayHeight: '45%' },
  };
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 640px)');
    const set = () => setIsMobile(mq.matches);
    set();
    mq.addEventListener('change', set);
    return () => mq.removeEventListener('change', set);
  }, []);
  const v = (isMobile ? variantStylesMobile[variant] : variantStyles[variant]) || variantStyles.principal;
  const heightPx = cardHeight ?? v.cardHeight;
  const widthPx = v.cardWidth;
  const bgSize = v.bgSize;
  const overlayH = v.overlayHeight;

  const handleMove = (id, e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width;
    const y = (e.clientY - rect.top) / rect.height;
    const px = 50 + (x - 0.5) * 12;
    const py = 50 + (y - 0.5) * 12;
    setBgPos((prev) => ({ ...prev, [id]: `${px}% ${py}%` }));
    setHovered((prev) => ({ ...prev, [id]: true }));
  };

  const handleLeave = (id) => {
    setBgPos((prev) => ({ ...prev, [id]: '50% 50%' }));
    setHovered((prev) => ({ ...prev, [id]: false }));
  };

  if (!produtos || produtos.length === 0) {
    return null;
  }

  return (
    <div className="carousel-wrapper">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h2 style={{ fontSize: isMobile ? '1.25rem' : '1.5rem', fontWeight: '600', color: titleColor, margin: 0, textAlign: 'left' }}>{titulo}</h2>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button 
            onClick={scrollLeft}
            style={{
              width: '40px', height: '40px', border: '1px solid #3b3b3b', background: '#2b2b2b',
              borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
              cursor: 'pointer', transition: 'all 0.2s', boxShadow: '0 2px 6px rgba(0,0,0,0.25)'
            }}
          >
            <ArrowLeft color="#000000" />
          </button>
          <button 
            onClick={scrollRight}
            style={{
              width: '40px', height: '40px', border: '1px solid #3b3b3b', background: '#2b2b2b',
              borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
              cursor: 'pointer', transition: 'all 0.2s', boxShadow: '0 2px 6px rgba(0,0,0,0.25)'
            }}
          >
            <ArrowRight color="#000000" />
          </button>
        </div>
      </div>
      
      <div style={{ position: 'relative', overflow: 'hidden' }}>
        <div 
          ref={carouselRef}
          style={{
            display: 'flex', gap: '16px', overflowX: 'auto', scrollBehavior: 'smooth',
            paddingBottom: '8px', scrollbarWidth: 'none', msOverflowStyle: 'none'
          }}
        >
          {produtos.map((produto) => (
            <div
              key={produto.id}
              onClick={() => onProdutoClick(produto)}
              style={{ flex: `0 0 ${widthPx}px`, cursor: 'pointer', overflow: 'visible', transformStyle: 'preserve-3d' }}
            >
              <div
                onMouseMove={(e) => handleMove(produto.id, e)}
                onMouseEnter={() => setHovered((prev) => ({ ...prev, [produto.id]: true }))}
                onMouseLeave={() => handleLeave(produto.id)}
                style={{
                  position: 'relative', borderRadius: '12px', overflow: 'hidden',
                  height: `${heightPx}px`, boxShadow: '0 8px 24px rgba(0,0,0,0.25)',
                  backgroundImage: `url(${produto.imagem ? `https://grubupload.s3.amazonaws.com/${produto.imagem}` : 'https://grubicons.s3.us-east-1.amazonaws.com/foto-padrao-grub-digital.jpg'})`,
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: hovered[produto.id] ? (bgPos[produto.id] || '50% 50%') : '50% 50%',
                  transition: 'background-position 0.08s ease-out, transform 0.18s ease',
                  transform: hovered[produto.id] ? 'scale(1.02) translateY(-2px)' : 'scale(1) translateY(0)',
                  willChange: 'transform, background-position',
                  boxShadow: hovered[produto.id] ? '0 10px 26px rgba(0,0,0,0.3)' : '0 8px 24px rgba(0,0,0,0.25)'
                }}
                className={`highlight-card highlight-${variant}`}
              >
                {produto.em_promocao && (
                  <div style={{
                    position: 'absolute', top: '12px', left: '12px', background: '#ef4444',
                    color: 'white', padding: '4px 8px', borderRadius: '6px',
                    fontSize: '0.75rem', fontWeight: '700'
                  }}>PROMOÇÃO</div>
                )}
                <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0, height: overlayH, background: 'linear-gradient(to top, rgba(0,0,0,0.75), rgba(0,0,0,0))' }} />
                <div style={{ position: 'absolute', left: '12px', right: '12px', bottom: '12px' }}>
                  {produto.categoria_nome && (
                    <div style={{ fontSize: isMobile ? '0.7rem' : '0.75rem', fontWeight: 600, color: '#d1d5db', letterSpacing: '0.04em', textAlign: 'left' }}>
                      {String(produto.categoria_nome).toUpperCase()}
                    </div>
                  )}
                  <div style={{ marginTop: '4px', fontSize: isMobile ? '0.95rem' : '1rem', fontWeight: 700, color: '#ffffff', lineHeight: '1.2', textAlign: 'left' }}>
                    {produto.nome}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>


    </div>
  );
}

export default ProdutoCarousel;
